module Meevo.Plugins.Interop {
    export class InteropActions {
        public static readonly GetSession = 'mi:GetSession';
        public static readonly ShowModalAlert = 'mi:ShowModalAlert';
        public static readonly ShowModalConfirm = 'mi:ShowModalConfirm';
        public static readonly ShowModalConfirmHandler = 'mi:ShowModalConfirmHandler';
        public static readonly ShowModalRedAlertConfirm = 'mi:ShowModalRedAlertConfirm';
        public static readonly ShowModalInfo = 'mi:ShowModalInfo';
        public static readonly CloseContext = 'mi:CloseContext';
        public static readonly GoToState = `mi:GoToState`;
        public static readonly AddCustomFormField = `mi:AddCustomFormField`;
        public static readonly AddCustomChartField = `mi:AddCustomChartField`;
        public static readonly DAFShowEditCustomFormFieldModal = `mi:DAF:ShowEditCustomFormFieldModal`;
        public static readonly DAFShowEditCustomChartFieldModal = `mi:DAF:ShowEditCustomChartFieldModal`;
        public static readonly DAFShowCopyCustomFormFieldModal = `mi:DAF:ShowCopyCustomFormFieldModal`;
        public static readonly DAFShowCopyCustomChartFieldModal = `mi:DAF:ShowCopyCustomChartFieldModal`;
        public static readonly DAFRemoveCustomFormFieldModal = `mi:DAF:DAFRemoveCustomFormFieldModal`;
        public static readonly DAFRemoveCustomChartFieldModal = `mi:DAF:DAFRemoveCustomChartFieldModal`;
        public static readonly DAFUndeleteCustomFormFieldModal = `mi:DAF:DAFUndeleteCustomFormFieldModal`;
        public static readonly DAFUndeleteCustomChartFieldModal = `mi:DAF:DAFUndeleteCustomChartFieldModal`;
        public static readonly CloseFormDesigner = `mi:CloseFormDesigner`;
        public static readonly CloseIntakeFormDesigner = `mi:CloseIntakeFormDesigner`;
        public static readonly ShowModalCustom = 'mi:ShowModalCustom';
        public static readonly StartBusyService = 'mi:StartBusyService';
        public static readonly StopBusyService = 'mi:StopBusyService';
        public static readonly ShowAuditHistoryModal = `mi:ShowAuditHistoryModal`;
        public static readonly SelectedSectionChanged = `mi:SelectedSectionChanged`;
        public static readonly Translate = "mi:Translate";
        public static readonly ApplyParamsToContext = "mi:ApplyParamsToContext";
        public static readonly ChildReady = "mi:ChildReady";
        /**
         * Child → host request for the params currently buffered for an interop
         * context. Pull counterpart to the ApplyParamsToContext push: a child that
         * boots (or re-enters its route) after the host has already buffered params
         * can fetch them itself instead of depending on the push having landed.
         */
        public static readonly GetContextParams = "mi:GetContextParams";
        public static readonly RefreshSession = 'mi:RefreshSession';
        public static readonly ReturnFromOnHold = "mi:ReturnFromOnHold";
        public static readonly AddPaymentRequestToSale = "mi:AddPaymentRequestToSale";
        public static readonly GetAppSettings = "mi:GetAppSettings";
        public static readonly GetWalkMeAppSettings = "mi:GetWalkMeAppSettings";
        public static readonly RefreshLockoutLastEventTime = "mi:RefreshLockoutLastEventTime";
        public static readonly GetTippyServiceUrl = "mi:GetTippyServiceUrl";
        public static readonly GetPendoData = "mi:GetPendoData";
        public static readonly NavigateTo = "mi:NavigateTo";
        public static readonly SendMessage = "mi:SendMessage";
        public static readonly OpenClientChart = "mi:OpenClientChart";
        public static readonly SetMaintenanceFormState = "mi:SetMaintenanceFormState";
        public static readonly SetNewColorTheme = "mi:SetNewColorTheme";
        // Sent by a Meevo shell v2 settings screen AFTER it has saved a
        // business-info change (e.g. the location-level enhanced-booking toggle).
        // The host re-pulls settings and patches its live caches so the change is
        // reflected without a logout/login. Fire this only once the save succeeds.
        public static readonly RefreshBusinessInfoSettings = "mi:RefreshBusinessInfoSettings";
    }
}
